import { useState, useEffect } from 'react';
import styles from './SetSupplier.module.scss';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
    selectSupplierId,
    selectUser,
    setSupplierHaveCustomizeReports,
    setSupplierInfo,
} from 'features/auth/slice';
import Select, {
    SingleValue,
    components,
    SingleValueProps,
    DropdownIndicatorProps,
} from 'react-select';
import { useNavigate } from 'react-router';
import { SupplierDropOption } from './type';
import { checkCustomizeReport } from './api';

export interface handleCloseInterface {
    handleClose?: () => void;
}

export default function SetSupplier({
    handleClose,
}: handleCloseInterface): JSX.Element {
    const navigate = useNavigate();

    const user = useAppSelector(selectUser);

    const supplierId = useAppSelector(selectSupplierId);

    const [defaultValue, setDefaultValue] = useState<SupplierDropOption>();

    const dispatch = useAppDispatch();

    const option: SupplierDropOption[] | undefined = user?.userSuppliers.map(
        (supplier) => ({
            value: supplier.supplierId,
            label: supplier.englishDescrption,
            businessType: supplier.businessType,
        }),
    );

    useEffect(() => {
        if (option) {
            if (supplierId && supplierId > 0) {
                const supplierVal = option.find((x) => x.value === supplierId);
                if (supplierVal) {
                    setDefaultValue(supplierVal);
                }
            } else {
                setDefaultValue(option[0]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [supplierId]);

    if (!user || !user.userSuppliers || user.userSuppliers.length === 1) {
        return <></>;
    }

    const onChange = async (supplier: SingleValue<SupplierDropOption>) => {
        if (supplier) {
            dispatch(setSupplierInfo(supplier));

            if (supplier.businessType === 10) {
                var checkCustomize = await checkCustomizeReport({
                    supplierId: supplier.value,
                });

                dispatch(
                    setSupplierHaveCustomizeReports(
                        checkCustomize.data.reportExist,
                    ),
                );
            }

            navigate('/');

            if (handleClose) {
                handleClose();
            }
        }
    };

    const DropdownIndicator = (
        props: DropdownIndicatorProps<SupplierDropOption, false>,
    ) => {
        return (
            <components.DropdownIndicator {...props}>
                <object
                    aria-label="DDI"
                    type="image/svg+xml"
                    data="/assets/images/svgs/swap.svg"></object>
            </components.DropdownIndicator>
        );
    };

    const SingleValue = ({
        children,
        ...props
    }: SingleValueProps<SupplierDropOption, false>) => (
        <components.SingleValue {...props}>
            <div className={styles.singleValue}>
                <span className={styles.icon}>
                    <object
                        aria-label="DDI"
                        type="image/svg+xml"
                        data="/assets/images/svgs/suppliers.svg"></object>
                </span>
                <div className={styles.supplierWrap}>
                    <div className={styles.singleValue_title}>
                        Change Supplier
                    </div>
                    <div className={styles.result}>{children}</div>
                </div>
            </div>
        </components.SingleValue>
    );

    return (
        <>
            {option ? (
                <Select
                    className={styles['basic-single']}
                    classNamePrefix="select"
                    components={{ DropdownIndicator, SingleValue }}
                    isSearchable={true}
                    name="color"
                    options={option}
                    menuPlacement="top"
                    onChange={(value) => onChange(value)}
                    value={defaultValue}
                />
            ) : null}
        </>
    );
}
